export default {
  'not-found': 'Página no encontrada',
  'internal-error': 'No se puede procesar la solicitud',
  'preview-error':
    '<strong>El slug del artículo no es válido</strong>.<br/> Comprueba que el campo slug esté completo y que el artículo haya sido <strong>publicado</strong> o <strong>guardado como borrador</strong>.',
  continue: 'Seguir navegando',
  'no-search-results': 'Nessun risultato trovato',
  'back-to-home': 'Torna in home',
}
